<template>
  <div class="col-md-6 col-sm-12">
    <div class="card order-card mt-3 mb-3 p3">
      <div class="card-body">
        <h5 class="card-title text-center">
          {{ order.type_title }}
        </h5>
        <h6 class="text-center">
          {{ order.location_name }}
        </h6>
        <div class="order-status text-center">
          {{ $t(order.status) }}
          <span class="order-detail-collapse" @click="btnCollpae()">
            <base-icon icon_name="menu" class="btn-expand" />
          </span>
        </div>
        <div
          class="progress"
          style="
            height: 24px;
            margin-left: 3px;
            border-radius: 9999px;
            background: #f1f1f1;
          "
        >
          <div
            v-if="order.status === 'Pending'"
            class="progress-bar"
            style="width: 20%; background-color: #d6ddab6e"
            role="progressbar"
          />
          <div
            v-if="order.status === 'Acknowledged'"
            class="progress-bar"
            style="width: 40%; background-color: #d6ddab6e"
            role="progressbar"
          />
          <div
            v-if="order.status === 'Preparing'"
            class="progress-bar"
            style="width: 60%; background-color: #d6ddab6e"
            role="progressbar"
          />
          <div
            v-if="order.status === 'Delivering'"
            class="progress-bar"
            style="width: 80%; background-color: #d6ddab6e"
            role="progressbar"
          />
          <div
            v-if="order.status === 'Done'"
            class="progress-bar"
            style="width: 100%; background-color: #d6ddab6e"
            role="progressbar"
          />
        </div>
        <br />
        <div v-if="collape">
          <div v-for="(item, index) in order.sale_details" :key="index" class>
            <div class="order-detail">
              <div class="title">
                {{ item.qty }} {{ item.venueitem_name }}
                <span class="price">{{ item.total | currencyFormat }}</span>
              </div>
              <div v-for="option in item.options" :key="option.id">
                &nbsp;&nbsp;&nbsp; __ + {{ option.title }} :
                <template v-for="opl in option.option_optionvalue">
                  <span :key="opl.id">{{ opl.optionvalue_title }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="order-total mt-3">
          <h5>
            {{ $t("Total") }} :
            {{ formatPrice(order.total * order.exchangerate) }}
            {{ order.currency_code }}
          </h5>
        </div>
        <div class="order-info">
          <p>{{ $t("order_id") }}: {{ order.id }}</p>
          <p>{{ $t("Time") }}: {{ formatDate(order.created_at) }}</p>
        </div>
        <div class="feed_back">
          <span @click="feedBack(order)"
            ><base-icon icon_name="feather" :size="15"></base-icon>
            {{ $t("feedback") }} |
          </span>
          <span @click="openReceipt(order)">{{ $t("Receipt") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import store from "@/store";
export default {
  name: "OrderCard",
  props: {
    order: Object,
  },
  data: () => ({
    collape: false,
  }),

  methods: {
    btnCollpae() {
      this.collape = !this.collape;
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("MM-DD-YYYY LT");
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async feedBack(sale) {
      console.log(sale);
      await store.dispatch("order/setSaleId", sale.id);
      await this.$router.push({ name: "feedback" });
    },
    async openReceipt(sale) {
      await this.$router.push({
        name: "order_detail",
        params: { orderId: sale.id },
      });
    },
  },
};
</script>

<style>
.feed_back {
  width: 50%;
  text-align: right;
  float: right;
  color: #700E57;
  cursor: POINTER;
  bottom: 0;
  margin-top: 20px;
}
.order-info {
  text-align: left;
  width: 50%;
  float: left;
}
.progress-bar {
  background-color: #d6ddab6e;
}

.order-card {
  margin-left: -10px;
  margin-right: -10px;
}
.order-status {
  /* border: 1px solid lightgrey; */
  border-radius: 20px;
  padding: 2px 10px 2px 10px;

  margin-bottom: -27px;
  z-index: 2;
  position: relative;
}
.order-detail {
  padding: 5px;
  border-radius: 10px;
}
.order-detail > .item_ > .price {
  float: right;
}
.order-detail > .item_ > .title {
  float: left;
}
.order-detail > .item_ > .price p {
  font-size: 13px;
}
.order-detail-collapse {
  float: right;
  margin-top: -3px;
  margin-left: 10px;
}
.order-total {
  text-align: right;
}
</style>